import { AxiosError } from 'axios'

import { api } from '@api'

import { useLogout } from '../useLogout'

const useAxiosInterceptors = () => {
  const { logout } = useLogout()

  api.interceptors.response.use(undefined, (error: AxiosError) => {
    if (error.response?.status === 401 || error.response?.data.message === '401 Unauthorized') {
      logout()
    }
    return Promise.reject(error)
  })
}

export { useAxiosInterceptors }
